const classes = {
    formControl: 'fs-form-control',
    codeInput: 'fs-code-input',
    passwordWrapper: 'fs-password-input-wrapper',
    passwordInputIcons: 'fs-password-input-icons',
    alert: 'fs-alert',
    sendButton: 'fs-send-btn',
    on: 'on',
    off: 'off'
}

const inputType = {
    text: 'text',
    password: 'password',
}

const events = {
    click: 'click',
    bind: 'bind',
    focus: 'focus',
    change: 'change',
    keydown: 'keydown',
    keyup: 'keyup',
    input: 'input',
}

class FormElements {

    constructor() {
        this.init();
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        const allInputs = [...document.querySelectorAll(`.${classes.formControl}`)]
        const codeInputs = [...document.querySelectorAll(`.${classes.formControl}.${classes.codeInput}`)]
        const passwordIconWrappers = [...document.querySelectorAll(`.${classes.passwordWrapper} .${classes.passwordInputIcons}`)]

        // hide all errors at input focus
        if (allInputs.length) {
            allInputs.map(input => {
                input.addEventListener(events.focus, this.handleHidingErrors, false);
            })
        }

        // toggle password visibility
        if (passwordIconWrappers.length) {
            passwordIconWrappers.map(iconWrapper => {
                iconWrapper.addEventListener(events.click, this.handleTogglePassword, false)
            })
        }

        // handle code input changes
        if (codeInputs.length) {
            codeInputs.map(input => {
                input.addEventListener(events.keyup, this.handleCodeInput.bind(this), false)
            })
        }

    }

    handleHidingErrors() {
        const errors = [...document.querySelectorAll(`.${classes.alert}`)]
        errors.map(error => {
            error.classList.add(classes.off);
        })
    }

    handleTogglePassword(e) {
        const parentNode = e.currentTarget.parentNode;
        const input = parentNode.querySelector('input');
        if (!parentNode.classList.contains(classes.on)) {
            parentNode.classList.add(classes.on);
            input.type = inputType.text;
            return;
        }
        parentNode.classList.remove(classes.on);
        input.type = inputType.password;
    }

    handleCodeInput(e) {
        const isNumberKey = e.code.includes('Digit');
        const isBackspace = e.key === 'Backspace';
        const isArrowRight = e.key === 'ArrowRight';
        const isArrowLeft = e.key === 'ArrowLeft';
        const isArrowUp = e.key === 'ArrowUp';
        const isArrowDown = e.key === 'ArrowDown';
        const currentValue = e.currentTarget.value;
        const newValue = currentValue.replace(/\D/g, '').slice(-1);


        switch (true) {
            case(isNumberKey):
                e.currentTarget.value = e.key;
                this.focusNextCodeInput(e);
                break;
            case(isArrowRight || isArrowUp):
                this.focusNextCodeInput(e);
                break;
            case(isBackspace || isArrowLeft || isArrowDown):
                this.focusPrevCodeInput(e);
                break;
            default:
                e.currentTarget.value = newValue;
        }
    }

    focusNextCodeInput(e) {
        const allInputs = [...e.currentTarget.parentNode.children];
        const currentIdx = allInputs.indexOf(e.currentTarget);
        const nextInput = allInputs[currentIdx + 1];
        const sendButton = document.querySelector(`.${classes.sendButton}`);

        if (nextInput) {
            nextInput.focus();
            return;
        }

        if (sendButton) {
            sendButton.focus();
        }
    }

    focusPrevCodeInput(e) {
        const allInputs = [...e.currentTarget.parentNode.children];
        const currentIdx = allInputs.indexOf(e.currentTarget);
        const prevInput = allInputs[currentIdx - 1];

        if (prevInput) {
            prevInput.focus();
        }
    }
}

export default FormElements;
